import evaluateRestQuery from "@/remoteState/evaluateRestQuery";

const VOCALIZER_URL = process.env.NEXT_PUBLIC_VOCALIZER_URL || "/vocalizer";

const requestTextToSpeechAudioFile = (text, languageCode) => {
  const requestUrl = `${VOCALIZER_URL}/text-to-speech`;
  const requestBody = { text, language_code: languageCode };
  const requestConfig = {
    method: "POST",
    body: JSON.stringify(requestBody),
    headers: { "Content-Type": "application/json" },
  };

  const request = new Request(requestUrl, requestConfig);

  return evaluateRestQuery(request);
};

export default requestTextToSpeechAudioFile;
